import { superstyled } from '@zenbusiness/zui/styles';

export const Container = superstyled({
  name: 'Transition',
  slot: 'Container',
  styles: () => ({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: 'calc(100dvh - 10rem)'
  })
});

export const Actions = superstyled({
  name: 'Transition',
  slot: 'Actions',
  styles: ({ theme }) => ({
    marginTop: theme.spacing(2),
    display: 'flex',
    gap: 1,
    justifyContent: 'center'
  })
});
